import { NgbDate } from '@ng-bootstrap/ng-bootstrap';

export class ReportScreen {
    airportName: string;
    numberFlight: number;
    startDate: NgbDate;
    endDate: NgbDate;   
    month: number;
    year: number;
}